import { Action, createReducer, on } from '@ngrx/store';
import { AuthState } from './auth.state';

import * as appActions from '@store/app/app.actions';
import * as authActions from '@store/auth/auth.actions';

export const initialAuth: AuthState = {
  phone: null,
  customer: null,
  isLoading: false,
  resend: false,
  error: false,
  countErrorOTP: 0,
  token: null,
  currentTime: 180,
};

const _authReducer = createReducer(
  initialAuth,
  on(authActions.requestLoginCode, (state, { phone, resend }) => {
    return {
      ...state,
      phone,
      resend,
      isLoading: true,
      error: false,
    };
  }),
  on(authActions.successRequestLoginCode, (state, { customer }) => {
    return {
      ...state,
      customer,
      isLoading: false,
      error: false,
      token: null,
    };
  }),
  on(authActions.failureRequestLoginCode, (state) => {
    return {
      ...state,
      error: true,
      isLoading: false,
      token: null,
    };
  }),
  on(appActions.requestLogin, (state) => {
    return {
      ...state,
      customer: null,
      resend: false,
      error: false,
    };
  }),
  on(appActions.stepBack, (state) => {
    return {
      ...state,
      customer: null,
      resend: false,
    };
  }),
  on(appActions.killPurchase, (state) => {
    return {
      ...state,
      customer: null,
      resend: false,
    };
  }),
  on(authActions.updateCountTimmerOTP, (state, { countErrorOTP }) => {
    return {
      ...state,
      countErrorOTP,
    };
  }),
  on(authActions.setCaptcha, (state, { token }) => {
    return {
      ...state,
      token,
    };
  }),
  on(authActions.setCurrentTime, (state, { currentTime }) => {
    return {
      ...state,
      currentTime,
    };
  }),
  on(appActions.successRequestLogin, (state) => {
    return {
      ...state,
      currentTime: 180,
    };
  })
);

export function authReducers(state: AuthState | undefined, action: Action) {
  return _authReducer(state, action);
}
